import { render, staticRenderFns } from "./applicationList.vue?vue&type=template&id=72502932&scoped=true&"
import script from "./applicationList.vue?vue&type=script&lang=js&"
export * from "./applicationList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72502932",
  null
  
)

export default component.exports